module.exports = __webpack_public_path__ + "static/media/Baxter_Customer.a14792b8.pdf";